<template>
  <div class="size margin">

    <div class="example">
      <titleComponent value="Inputs" mark="01" color="background-yellow" />

      <div class="container column padding-top-20 border-box">

        <div class="container column esp flex-grow-1">

          <div class="esp container column">
            <div class="subtitle margin-bottom-10">
              <h4>Simple</h4>
            </div>

            <div class="flex-grow-1 box-input">
              <div class="input-space container align-items-center">
                <input type="text" placeholder="Placeholder" class="input input-sm">
              </div>
            </div>

            <div class="flex-grow-1 box-input">
              <div class="input-space container align-items-center">
                <input type="text" placeholder="Placeholder" class="input">
              </div>
            </div>

            <div class="flex-grow-1 box-input">
              <div class="input-space container align-items-center">
                <input type="text" placeholder="Placeholder" class="input input-lg">
              </div>
            </div>

          </div>

          <div class="esp container column">
            <div class="subtitle margin-bottom-10">
              <h4>Icons</h4>
            </div>

            <div class="flex-grow-1 box-input">
              <div class="input-space container align-items-center">
                <div class="icons">
                  <i class="fas fa-user"></i>
                </div>
                <input type="text" placeholder="Placeholder" class="input">
              </div>
            </div>

          </div>

          <div class="esp container column">
            <div class="subtitle margin-bottom-10">
              <h4>Feedback</h4>
            </div>

            <div class="flex-grow-1 box-input">
              <div class="input-space input-error container align-items-center">
                <div class="icons">
                  <i class="fas fa-user"></i>
                </div>
                <input type="text" placeholder="Digite seu nome" class="input">
                <span class="feed-icon"><i class="fas fa-times-circle"></i></span>
              </div>
            </div>

            <div class="flex-grow-1 box-input">
              <div class="input-space input-warning container align-items-center">
                <div class="icons">
                  <i class="fas fa-user"></i>
                </div>
                <input type="text" placeholder="Digite seu nome" class="input">
                <span class="feed-icon"><i class="fas fa-exclamation-circle"></i></span>
              </div>
            </div>

            <div class="flex-grow-1 box-input">
              <div class="input-space input-success container align-items-center">
                <div class="icons">
                  <i class="fas fa-user"></i>
                </div>
                <input type="text" placeholder="Digite seu nome" class="input">
                <span class="feed-icon"><i class="fas fa-check"></i></i></span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
  import titleComponent from '@/components/titleComponent'
  import inputComponent from '@/components/input'
  export default {
    components: {
      titleComponent,
      inputComponent
    },
    name: 'buttons',
    data() {
      return {

        value2: true,
        value1: '',

        input: '',
        input3: '',
        input4: '',
        input5: '',
        select: '',

        checkAll: false,
        checkedCities: [],
        isIndeterminate: true,
        options: [{
          value: 'Option1',
          label: 'Option1'
        }, {
          value: 'Option2',
          label: 'Option2'
        }, {
          value: 'Option3',
          label: 'Option3'
        }, {
          value: 'Option4',
          label: 'Option4'
        }, {
          value: 'Option5',
          label: 'Option5'
        }],
        value: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .esp {
    margin-bottom: 20px;
  }

  .box-input {
    margin-bottom: 5px;
    padding: 5px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/styleguide/inputs.vue